// Campus photo for /colleges/california-state-university-long-beach: CC BY-SA 2.5, by Summum, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AWalter_Pyramid.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/california-state-university-long-beach/; credited under the photo.
const photo = {
    "slug": "california-state-university-long-beach",
    "alt": "The Walter Pyramid arena at Cal State Long Beach under a clear sky, with lawn and young trees in front",
    "src": "/colleges/california-state-university-long-beach/campus-1600.webp",
    "srcSmall": "/colleges/california-state-university-long-beach/campus-800.webp",
    "srcMid": "/colleges/california-state-university-long-beach/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/california-state-university-long-beach/og.jpg",
    "title": "Walter Pyramid",
    "author": "Summum",
    "license": "CC BY-SA 2.5",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.5",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AWalter_Pyramid.jpg",
    "read": "2026-10-01"
};

export default photo;
